import React from 'react';
import { Link } from 'react-router-dom';
import { DAYS } from '../../lib/barbers/helpers';

// Right-hand schedule editor — booking policy dropdowns, holidays
// link, weekly-hours table. `updateHour` mutates the parent-owned
// `hours` state; `handleSaveHours` batches a barbers-row update plus
// a full replace of the barber_hours rows.
export const ScheduleHoursPanel = ({
  selectedBarber, hours, updateHour, handleSaveHours,
  policyNotice, setPolicyNotice, policyWindow, setPolicyWindow,
}) => (
  <div className="panel hours-panel">
    <div className="ph">
      <h3>{selectedBarber.name} — schedule</h3>
      <button className="btn s" onClick={handleSaveHours}>
        Save Changes
      </button>
    </div>

    <div className="policy-inline">
      <div className="pi-field">
        <label>Minimum notice</label>
        <select className="inp" value={policyNotice}
          onChange={(e) => setPolicyNotice(Number(e.target.value))}
          data-testid={`barber-notice-${selectedBarber.id}`}>
          <option value={1}>1 hour</option>
          <option value={2}>2 hours</option>
          <option value={3}>3 hours</option>
          <option value={4}>4 hours</option>
          <option value={5}>5 hours</option>
          <option value={24}>1 day (24 hours)</option>
          <option value={48}>2 days (48 hours)</option>
        </select>
      </div>
      <div className="pi-field">
        <label>Booking window</label>
        <select className="inp" value={policyWindow}
          onChange={(e) => setPolicyWindow(Number(e.target.value))}
          data-testid={`barber-window-${selectedBarber.id}`}>
          <option value={7}>1 week ahead</option>
          <option value={14}>2 weeks ahead</option>
          <option value={21}>3 weeks ahead</option>
          <option value={28}>4 weeks ahead</option>
          <option value={42}>6 weeks ahead</option>
          <option value={56}>8 weeks ahead</option>
          <option value={84}>12 weeks ahead</option>
        </select>
      </div>
      <div className="pi-field pi-link">
        <Link
          className="btn s"
          to={`/settings/schedule?barber=${selectedBarber.id}`}
          data-testid={`barber-exceptions-${selectedBarber.id}`}
        >
          Manage holidays & exceptions →
        </Link>
      </div>
    </div>

    <h4 className="hp-sub">Weekly hours</h4>
    <div className="hours-table">
      {DAYS.map(day => {
        const dayHours = hours.find(h => h.weekday === day.value) || {
          weekday: day.value,
          start_time: '09:00',
          end_time: '18:00',
          is_open: true,
        };

        return (
          <div key={day.value} className={`hrow ${!dayHours.is_open ? 'closed' : ''}`}>
            <span className="day">{day.label}</span>
            <label className="tog">
              <input
                type="checkbox"
                checked={dayHours.is_open}
                onChange={(e) => updateHour(day.value, 'is_open', e.target.checked)}
              />
              <span className="tog-slider"></span>
            </label>
            {dayHours.is_open ? (
              <div className="times">
                <input
                  type="time"
                  className="timebox"
                  value={dayHours.start_time}
                  onChange={(e) => updateHour(day.value, 'start_time', e.target.value)}
                />
                <span>–</span>
                <input
                  type="time"
                  className="timebox"
                  value={dayHours.end_time}
                  onChange={(e) => updateHour(day.value, 'end_time', e.target.value)}
                />
              </div>
            ) : (
              <div className="times">Closed</div>
            )}
          </div>
        );
      })}
    </div>
  </div>
);
